import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { DateRange } from './../../../_shared/model/utils/dateRange.model';
import { HelperService } from './../../../_shared/services';
@Component({
    selector: 'com-filter',
    templateUrl: './com-filter.component.html',
    styleUrls: ['./com-filter.component.scss'],
})
export class ComFilterComponent implements OnInit {
    @Input()
    settings: { isSearch: boolean; isDateSelection: boolean; isPortlet: boolean; searchField: string[] } = {
        isSearch: false,
        isDateSelection: true,
        isPortlet: true,
        searchField: [],
    };

    @Input()
    dateRange: DateRange = new DateRange().deserialize({
        start: moment().subtract(1, 'week'),
        end: moment(),
        label: 'Danes',
    });

    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData: any[];

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    onDateChange: EventEmitter<DateRange> = new EventEmitter();

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    onValueChange: EventEmitter<any[]> = new EventEmitter();

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public options: any = this.helper.getDateRangeSettngs();
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public daterangeCal: any = this.dateRange;
    // public data: any[] = [];
    // public dataCopy: any[] = [];

    constructor(public helper: HelperService) {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
    ngOnInit() {}

    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public selectedDate(value: any, datepicker?: any) {
        // any object can be passed to the selected event and it will be passed back here
        datepicker.start = value.start;
        datepicker.end = value.end;
        // or manupulat your own internal property
        this.daterangeCal.start = value.start;
        this.daterangeCal.end = value.end;
        this.daterangeCal.label = value.label;
        this.onDateChange.emit(this.daterangeCal);
    }

    public updateFilter(event): void {
        const val = event.target.value.toLowerCase();
        if (!val) {
            this.onValueChange.emit(this.searchData);
        } else {
            const filtered = this.searchData?.filter(el => {
                let isMatch = false;
                // TODO Ignored with eslint-interactive on 2023-11-10
                // eslint-disable-next-line no-unsafe-optional-chaining
                for (const searchName of this.settings?.searchField) {
                    if (el[searchName]?.toLowerCase()?.indexOf(val) != -1 && el[searchName]?.toLowerCase()?.indexOf(val) != undefined) {
                        isMatch = true;
                    }
                }
                return isMatch;
            });
            this.onValueChange.emit(filtered);
        }
    }
}
